export { default } from "./SlicerTags"
